import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useConfiguracionSitio } from "./Configuracion/ContextoConfiguracionSitio";

const WhatsAppButton = () => {
  const { personalizacion } = useConfiguracionSitio();
  const numeroWhatsApp = personalizacion.whatsapp_numero;

  const handleWhatsAppClick = () => {
    const mensaje = encodeURIComponent(personalizacion.whatsapp_mensaje);
    window.open(`https://wa.me/${numeroWhatsApp}?text=${mensaje}`, "_blank", "noopener,noreferrer");
  };

  if (personalizacion.mostrar_whatsapp !== "si" || !numeroWhatsApp) return null;

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-4 right-4 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-green-500 text-white shadow-lg transition-all duration-300 ease-in-out hover:scale-110 hover:bg-green-600 active:scale-95 sm:bottom-6 sm:right-6 sm:h-16 sm:w-16"
      title="Contactar por WhatsApp"
      aria-label="Abrir WhatsApp"
    >
      <FaWhatsapp className="text-2xl text-white sm:text-3xl" aria-hidden="true" />
    </button>
  );
};

export default WhatsAppButton;
